var Isotope = require('isotope-layout')
/*===================================================================================*/
/* Grants */
/*===================================================================================*/
var inGrants = $('#grants').length > 0
window.newIso = null
if (inGrants) {
    window.setTimeout(function () {
        var f = window.location.hash == '' ? '.category' : '.' + window.location.hash.replace('#', '')
        window.newIso = new Isotope('.items', {
            itemSelector: '.item',
            filter: f,
        })
    }, 200)

    var resizeTimer

    function resizeFunction() {
        var f = window.location.hash == '' ? '.category' : '.' + window.location.hash.replace('#', '')
        if (iso != undefined) {
            window.newIso.destroy()
        }
        window.newIso = Isotope('.items', {
            itemSelector: '.item',
            filter: f,
        })
    }

    $(window).resize(function () {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(resizeFunction, 100)
    })
    $('a.panel-toggle.collapsed').click(function () {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(resizeFunction, 100)
    })
    $('.portfolio .filter li a').click(function () {
        $('.portfolio .filter li a').removeClass('active')
        $(this).addClass('active')
        var selector = $(this).attr('data-filter')
        window.newIso.destroy()
        window.newIso = new Isotope('.items', {
            filter: selector,
        })
        return false
    })
}
